//Please add the language resource
const intDatapack = {
  businessType:'业务类型',
  clazzName:'类名',
  methodName: '方法名',
  methodRequestMapping: '方法',
  requestData: '请求消息',
  requestTime:'请求时间',
  responseData:'响应消息',
  responseTime:'响应时间',
  useTime:'用时（单位：毫秒）',
  createTime:'创建时间',

  msg:{
  }
};
export default intDatapack



// WEBPACK FOOTER //
// ./src/page/log/intDatapack/lang/intDatapack.en.js